//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import distributionRegionMixin from '@/mixins/distributionRegion';
import { getCommissionList } from '@/api/distributionAlliance';
var ROLE = {
  LEADER: '团长',
  AGENT: '区代',
  AGENT_CITY: '市代',
  AGENT_PROVINCE: '省代',
  AGENT_ORIGIN: '招募代理',
  DIRECT: '直推奖励',
  INDIRECT: '间推奖励',
  TEAM: '团队奖励',
  REGION_BONUS: '区域奖励'
};
var STATUS = {
  0: '待结算',
  1: '结算中',
  2: '已入账',
  3: '已失效'
};
export default {
  mixins: [distributionRegionMixin],
  name: 'AllianceCommission',
  data: function data() {
    return {
      loading: false,
      list: [],
      users: {},
      total: 0,
      dateRange: [],
      query: {
        role: '',
        regionPrefix: '',
        status: null,
        uid: null,
        agentId: null,
        orderNo: '',
        page: 1,
        size: 20
      }
    };
  },
  created: function created() {
    this.loadList(1);
  },
  methods: {
    roleText: function roleText(r) {
      return ROLE[r] || r || '-';
    },
    roleTagType: function roleTagType(r) {
      return {
        LEADER: 'success',
        AGENT: '',
        AGENT_CITY: '',
        AGENT_PROVINCE: '',
        AGENT_ORIGIN: 'warning',
        DIRECT: 'success',
        INDIRECT: 'warning',
        TEAM: 'danger',
        REGION_BONUS: 'info'
      }[r] || 'info';
    },
    statusText: function statusText(s) {
      return STATUS[s] || '-';
    },
    statusTagType: function statusTagType(s) {
      return {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'danger'
      }[s] || 'info';
    },
    money: function money(value) {
      return '￥' + Number(value || 0).toFixed(2);
    },
    // 后端存的是万分比（RATIO_BASE = 10000），不是百分比。直接当百分数显示会差 100 倍
    ratioText: function ratioText(ratio) {
      return (Number(ratio || 0) / 100).toFixed(2) + '%';
    },
    userName: function userName(uid) {
      var u = this.users[uid];
      return u ? u.nickname || '(未设置昵称)' : '查无此人';
    },
    loadList: function loadList(page) {
      var _this = this;
      if (page) this.query.page = page;
      var params = {};
      Object.keys(this.query).forEach(function (key) {
        var value = _this.query[key];
        if (value !== '' && value !== null && value !== undefined && !Number.isNaN(value)) {
          params[key] = value;
        }
      });
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      this.loading = true;
      getCommissionList(params).then(function (res) {
        _this.list = res && res.list || [];
        _this.users = res && res.users || {};
        _this.total = res && res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    onSizeChange: function onSizeChange(size) {
      this.query.size = size;
      this.loadList(1);
    },
    reset: function reset() {
      this.dateRange = [];
      this.query = {
        role: '',
        regionPrefix: '',
        status: null,
        uid: null,
        agentId: null,
        orderNo: '',
        page: 1,
        size: 20
      };
      this.loadList(1);
    }
  }
};